import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  id: 'vue-histogram',
  class: "hidden md:block md:w-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "slider-wrapper" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    id: 'histogram-slider',
    name: 'histogram-slider',
    value: ""
  })
], -1)
const _hoisted_4 = { class: "histogram-text hidden lg:block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Date = _resolveComponent("Date")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.style),
      class: "histo h-16 mx-auto flex md:h-32 md:absolute md:bottom-5 md:bg-white md:opacity-80 md:p-6 md:rounded-2xl"
    }, [
      _createElementVNode("span", {
        class: "hidden md:block icon icon-calendar text-4xl text-right color-secondary cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMinDateVisibility && _ctx.toggleMinDateVisibility(...args)))
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2)),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("histogram.text")), 1)
      ]),
      _createElementVNode("span", {
        class: "hidden md:block icon icon-calendar text-4xl text-right color-secondary cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMaxDateVisibility && _ctx.toggleMaxDateVisibility(...args)))
      })
    ], 4),
    _createVNode(_component_Date, {
      visible: _ctx.minDateVisibility,
      toggleVisible: _ctx.toggleMinDateVisibility,
      isMinDate: true
    }, null, 8, ["visible", "toggleVisible"]),
    _createVNode(_component_Date, {
      visible: _ctx.maxDateVisibility,
      toggleVisible: _ctx.toggleMaxDateVisibility,
      isMinDate: false
    }, null, 8, ["visible", "toggleVisible"])
  ], 64))
}